import { render, staticRenderFns } from "./EmbedCode.vue?vue&type=template&id=904fad6c&scoped=true"
import script from "./EmbedCode.vue?vue&type=script&lang=js"
export * from "./EmbedCode.vue?vue&type=script&lang=js"
import style0 from "./EmbedCode.vue?vue&type=style&index=0&id=904fad6c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "904fad6c",
  null
  
)

export default component.exports